<label class="checkbox-label">
  <input type="checkbox" [checked]="selected" [disabled]="disabled" [tabindex]="tabindex"
    (click)="clickOutput.emit($event)" (change)="onChange($event)" #checkbox />
  <span [class]="fontFamilyClass" [style.font-size.px]="fontSize">{{label}}</span>
</label>
